
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.8 9.6v-3H7.2a.6.6 0 01-.6-.6V2.4H1.2v7.2h9.6zm-3-6.403V5.4h2.203L7.8 3.197zM0 2.4a1.2 1.2 0 011.2-1.2h6.051a.6.6 0 01.425.176l4.148 4.148a.6.6 0 01.176.424V9.6a1.2 1.2 0 01-1.2 1.2H1.2A1.2 1.2 0 010 9.6V2.4z","fill":"#B5B5B5"}})])
          )
        }
      }
    